import { createApiClient, createApi, type Api } from '@cmms/api-client'
import { useAuthStore } from '../store/authStore'
import { useCustomerStore } from '../store/customerStore'

export const baseUrl = import.meta.env.VITE_API_BASE_URL || ''

const client = createApiClient({
  baseUrl,
  getAccessToken: () => useAuthStore.getState().accessToken,
  getRefreshToken: () => useAuthStore.getState().refreshToken,
  // Needed by the refresh flow — the access token backing a refresh
  // call may already be expired, so the server resolves org context
  // from this instead of the JWT. Already persisted on `user` from
  // the last successful login/`/me` call, independent of token state.
  getOrgSlug: () => useAuthStore.getState().user?.org_slug ?? null,
  onTokenRefresh: (access, refresh) => {
    useAuthStore.getState().setTokens(access, refresh)
  },
  onAuthError: () => {
    useAuthStore.getState().clear()
  },
  // Active customer context — null = consolidated (All), uuid = scoped
  // to that one customer. Read live from the store so the next request
  // picks up the new value the instant the user flips the switcher.
  getCustomerId: () => useCustomerStore.getState().customerId,
  getGroupScope: () => useCustomerStore.getState().groupScope,
})

export const api: Api = createApi(client)
